import {apiGet} from '@api/api'

export interface INavNotification {
    created_at?: number
    data?: any
    deep_link?: string
    group_id?: string
    is_read?: boolean
    recipient_id?: string
    thumbnail?: string
    type?: string
    type_icon_url?: string
    updated_at?: number
    _id?: string
}

export const apiGetNotifications = async (limit: number, skip: number) => {
    return await apiGet<INavNotification[]>(`notification?l=${limit}&s=${skip}`)
}
